import React from "react";
import veg from "./image/veg.png";
import nveg from "./image/nveg.png";
import { connect } from "react-redux";
import * as handler from "../Actions/main";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import "./item.css";

function CartItem(props) {
  let flagv = 0;
  let type;

  for (let i = 0; i < props.cat.additionalTags.length; i++) {
    if (props.cat.additionalTags[i] === "Veg") flagv = 1;
  }

  if (flagv === 1) type = veg;
  else type = nveg;

  return (
    <Grid item xs={12}>
      <Grid container alignItems="center" spacing={2}>
        {/* <Grid item xs={1} style={{ paddingRight: 0 }}>
         
        </Grid> */}

        <Grid item xs={5}>
          <p style={{ marginBottom: 0, overflowWrap: "break-word" }}>
            {" "}
            <img src={type} alt="type" height={14} width={14} />{" "}
            {props.cat.itemName}
          </p>
        </Grid>

        <Grid item xs={3} style={{ padding: 1, maxWidth: "120px" }}>
          <Grid
            container
            alignItems="center"
            style={{ border: "1px solid green", backgroundColor: "white" }}
            spacing={1}
          >
            <Grid item xs={4}>
              <Typography
                onClick={() => props.del(props.cat.itemId)}
                align="center"
                color="textSecondary"
                variant="h5"
              >
                <span style={{ fontSize: "18px" }}>-</span>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography align="center" color="textSecondary" variant="h5">
                <span style={{ fontSize: "18px" }}>{props.cat.quantity}</span>
              </Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography
                onClick={() => props.click2(props.cat.itemId)}
                align="center"
                color="textSecondary"
                variant="h5"
              >
                <span style={{ fontSize: "18px" }}>+</span>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <span style={{ float: "right", marginRight: 2 }}>
            {" "}
            ₹{(props.cat.PriceMap.TotalPrice * props.cat.quantity).toFixed(2)}
          </span>
        </Grid>
      </Grid>
    </Grid>
  );
}
const mapDispatchToProps = dispatch => {
  return {
    click2: itemId => dispatch(handler.addItem(itemId)),
    del: itemId => dispatch(handler.deleteItem(itemId))
  };
};
const mapStateToProps = state => {
  return {
    cart: state.menuR.cart
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CartItem);
